import type { ReceiptTemplate } from '../schema';

export const chickFilATemplate: ReceiptTemplate = {
  id: 'chick-fil-a',
  name: 'Chick-fil-A Receipt',
  brand: 'CHICK-FIL-A',
  description: 'Fast food restaurant receipt template',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'narrow',
  },
  sections: [
    {
      id: 'cfa-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/chick-fil-a.png',
        logoData: '',
        logoWidth: 120,
        logoHeight: 50,
        businessName: '',
        businessNameFontSize: 20,
        addressLines: [
          '1200 Dark Avenue',
          'Monsterville, CA 94608',
          '(510) 555-0127',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'cfa-order',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'Order #127',
        fontSize: 20,
        showDivider: true,
        dividerStyle: 'spaces',
        isBold: true,
      },
    },
    {
      id: 'cfa-trans',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'DINE IN\n01/04/26  12:18:42  REG 02',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'cfa-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        showQuantity: true,
        showPrice: true,
        showTotal: false,
        items: [
          { id: 'cfa-item-1', name: 'CFA SANDWICH MEAL', quantity: '1', price: '10.35'},
          { id: 'cfa-item-2', name: '  MED WAFFLE FRIES', quantity: '1', price: '0.00'},
          { id: 'cfa-item-3', name: '  MED LEMONADE', quantity: '1', price: '0.00'},
          { id: 'cfa-item-4', name: 'NUGGETS 8CT', quantity: '1', price: '5.15'},
          { id: 'cfa-item-5', name: 'CFA SAUCE', quantity: '2', price: '0.00'},
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'cfa-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 35,
        labelAlignment: 'left',
        lines: [
          { id: 'cfa-subtotal', label: 'Subtotal', value: '15.50', isBold: false, isLarge: false },
          { id: 'cfa-tax', label: 'Tax', value: '1.38', isBold: false, isLarge: false },
          { id: 'cfa-total', label: 'Total', value: '16.88', isBold: true, isLarge: true },
        ],
        increaseTotalSize: true,
        totalSizeIncrease: 20,
        showDivider: true,
        dividerStyle: 'double',
      },
    },
    {
      id: 'cfa-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        paymentType: 'card',
        cardFields: [
          { id: 'cfa-card', label: 'VISA', value: '************4144' },
          { id: 'cfa-auth', label: 'AUTH', value: '847291' },
        ],
        cashFields: [],
        showDivider: true,
        dividerStyle: 'spaces',
      },
    },
    {
      id: 'cfa-barcode',
      type: 'barcode',
      enabled: true,
      config: {
        alignment: 'center',
        type: 'code128',
        value: '127847291010426',
        showValue: false,
        width: 1.5,
        height: 35,
        showDivider: false,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'cfa-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'CFASURVEY.COM\nTELL US ABOUT YOUR VISIT\n\nIt\'s our pleasure to serve you!',
        fontSize: 10,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
};

